/*eslint no-console: 0*/
import config from '../../lib/config'
const EventBus = window.VueEventBus

import PageMixins from '../../components/_mixins/pages'
import CartMixins from '../../components/_mixins/location-checkout'
import ScrollMixins from '../../components/_mixins/scroller'
import ContentMixins from './content'

import WouldYouLikeTo from '../../components/parts/would-you-like-to'

import CartBilling from './billing'
import CartFinal from './final'

import { required, minValue, decimal, email, sameAs } from 'vuelidate/lib/validators'
import axios from 'axios'
import { getFirstErrorMessage } from '~/lib/axios'
import {raceType} from '../../vuexstore/modules/race'
import {parseDateTime, parseDateInterval} from '../../lib/dates'

export default {
  name: 'page-cart',
  translations: 'page.cart',
  settings: 'page.cart',
  mixins: [
    PageMixins,
    CartMixins,
    ScrollMixins,
    ContentMixins
  ],

  components: {
    CartBilling,
    CartFinal,
    WouldYouLikeTo,
  },

  props: ['waiver'],

  data: () => ({
    waiverUrl: null,
    loginUri: null,
    registerUri: null,
    generalAlertMessage: '',
    generalAlertMessages: [],
    showClearCartPrompt: false,
    showLoginPrompt: false,
    loginPromptText: 'Please sign in to your account to complete the billing.',
    showItemRates: false,
    showGiftcardFullPartialModal: false,
    showGiftcardAmountModal: false,
    acceptedCards: config.ACCEPTED_CARDS,
    columnClasses: {
      title: 'flex-child-grow',
      date: 'w10',
      quantity: 'w10',
      rate: 'w10',
      amount: 'w10',
      tax: 'w10',
      total: 'w10',
    },
    headerItem: {
      title: 'PRODUCT NAME',
      date: 'DATE & TIME',
      quantity: 'QUANTITY',
      rate: 'PRICE',
      amount: 'SUB TOTAL',
      tax: 'TAX',
      total: 'TOTAL',
    },
    giftcard: {
      number: null,
      cvv: null,
      amount: null,
      isAdding: false,
      error: null,
      isAdded: false,
      itemId: null,
      notApplied: false
    },
    coupon: {
      code: null,
      isAdding: false,
      error: null,
      isAdded: false,
      notApplied: false
    },
    // costDetails: {},
    items: null,
    order: null,
    showCheckoutAsGuestModal: false,
    guestEmailRegistered: false,
    guestEmail: null,
    guestEmailConfirmation: null,
    isCheckingGuestEmail: false,

    isSubmitting: false,
    isValidating: false,
    // valid: false,
    // validationError: null,
    selectedRedemption: 'coupon',
    redemptionTypes: {
      coupon: {
        title: 'Coupon code'
      },
      giftcard: {
        title: 'Gift card'
      },
    }
  }),

  validations: {
    giftcard: {
      number: {
        required,
      },
      cvv: {
        required,
      },
      amount: {
        required,
        decimal,
        minValue: minValue(0.01),
        maxDecimals: v => ((Number(v).toFixed(2) - v) === 0),
      },
    },
    giftcardApplyGroup: [
      'giftcard.number', 'giftcard.cvv',
    ],
    coupon: {
      code: {
        required,
      },
    },

    guestEmail: {
      required,
      email,
    },
    guestEmailConfirmation: {
      required,
      email,
      sameAs: sameAs('guestEmail'),
    },
    guest: [
      'guestEmail', 'guestEmailConfirmation'
    ],
  },
  watch: {
    'coupon.code'(v) {
      this.coupon.error = null
    },
    'giftcard.number'(v) {
      this.giftcard.error = null
    },
    'giftcard.cvv'(v) {
      this.giftcard.error = null
    },
    checkoutState: {
      handler: function (newValue, oldValue) {
        if (!newValue || newValue === 'cart') {
          this.$nextTick(() => {
            // console.log('go to cart page')
            this.scrollToTop()
          })
        }
      },
      immediate: true
    }
  },
  created() {
    // this.hideGlobalTimer(true)

    this.waiverUrl = this.waiver
    if (!this.isBillingStep) {
      this.setBillingTotal(false)
      this.setBillingGuestEmail(false)
      this.setCheckoutState('cart')
    }
    this.loginUri = this.getRouteUrl('page-login')
    this.registerUri = this.getRouteUrl('page-registration')
    EventBus.$on('cart.unauthenticated', () => {
        //this.showLoginPrompt = true
    })

    EventBus.$on('cart.error', x => {
      this.setCostDetails(null)
    })

    EventBus.$once('cart.validated', x => {
      this.setCostDetails(x)
      this.setValidationError()
      if (!this.currentCartIsEmpty && this.loginRedirectSection === 'billing') {
        this.setPostLoginSection(null)
        this.tryGotoBilling()
      }
    })
    EventBus.$on('cart.paying', () => {
      this.items = _.cloneDeep(this.currentCartItems)
    })
    EventBus.$on('cart.paid', order => {
      this.order = order
    })

    EventBus.$on('cart.general.messages.collect', messages => {
      this.getOverlappingReservationMessages(messages)
    })

    EventBus.$emit('cart.general.messages.collect', this.generalAlertMessages)

    this.showGeneralAlert()
  },

  mounted() {
  },
  computed: {
    isGeneralAlertVisible() {
      return !this.currentCartIsEmpty && !this.isAlertOnTimeoutShown && !this.showLoginPrompt && !this.showClearCartPrompt
    },
    isGeneralAlertShown() {
      return this.isGeneralAlertVisible && this.generalAlertMessage  && this.isGeneralAlertPopupShown
    },
    isBillingStep() {
      return this.checkoutState === 'billing' && this.isBillingError
    },
    billingEnabled() {
      return this.costDetails.total > 0
    },
    wouldYouLikeBlocks() {
      const blocks = this.getFilteredWouldYouLikeBlocks()
      return this.translateProductName(blocks, ['title', 'message'])
    }
  },
  methods: {
    getOverlappingReservationMessages(messages) {
      const isOverlapping = this.findOverlappingReservations()
      if (isOverlapping) {
        messages.push('You have reservations time overlapping for Ninja Wipeout and Race bookings. Please make sure to edit your time selection, if required.')
      }
    },
    findOverlappingReservations() {
      const items = _.pickBy(this.currentCartItems, ({type = null}) => type === raceType)
      const ninjas = _.pickBy(items, ({attributes: {raceType = null}}) => raceType === 'ninja')
      const pros = _.pickBy(items, ({attributes: {raceType = null}}) => raceType === 'pro')
      if (_.isEmpty(ninjas) || _.isEmpty(pros)) {
        return false
      }
      const ninjasTime = _.mapValues(ninjas, item => {
        const starts = parseDateTime(item.attributes.slot.datetime)
        const ends = starts.plus({hours: 1 * item.attributes.form.numberOfHours, minutes: 0, seconds: 1})
        const interval = starts.until(ends)//parseDateInterval
        return {interval, starts, ends}
      })
      const prosTime = _.mapValues(pros, item => {
        const slots = item.attributes.form.selectedSlots
        let starts = null
        let ends = null
        _.forOwn(slots, slot => {
          const slotStarts = parseDateTime(slot.datetime)
          const slotEnds = slotStarts.plus({minutes: 10, seconds: 1})
          if (_.isNil(starts)) {
            starts = slotStarts
          }
          if (_.isNil(ends)) {
            ends = slotEnds
          }
          if (slotStarts < starts) {
            starts = slotStarts
          }
          if (slotEnds > ends) {
            ends = slotEnds
          }
        })
        const interval = starts.until(ends)
        return {interval, starts, ends}
      })
      return _.some(ninjasTime, ninja => {
        return _.some(prosTime, pro => {
          return ninja.interval.overlaps(pro.interval)
        })
      })
    },
    showGeneralAlert() {
      if (this.isGeneralAlertVisible && this.generalAlertMessages.length) {
        this.generalAlertMessage = this.generalAlertMessages.shift() || null
        if (this.generalAlertMessage) {
          this.showGeneralAlertPopup()
        }
      }

    },
    hideGeneralAlert() {
      this.generalAlertMessage = ''
      this.showGeneralAlertPopup(false)
      this.showGeneralAlert()
    },

    async cartSubmitButtonClicked($event) {
      const args = {$event, items: this.currentCartItems, cart: this, click: {}}

      await EventBus.$$emitAsync('cart.process.before', args)

      if (args.click.cancel) {
        return
      }

      await this.tryGotoBilling()
    },

    async tryGotoBilling() {
      if (this.isValidating) {
        return
      }
      if (this.authUser) {
        this.gotoBilling()
      } else {
        const cardsOnly = Object.values(this.currentCartItems).filter(x => !(['gift_cards', 'playcard_voucher', 'playcard_reload'].includes(x.type))).length === 0
        if (cardsOnly) {
          this.showCheckoutAsGuestModal = true
        } else {
          this.showLoginPrompt = true
        }
      }
    },

    async checkGuestEmail() {
      try {
        this.guestEmailRegistered = false
        this.isCheckingGuestEmail = true
        await axios.post(`${window.addiesaas.url}/api/user/register/validate-email`, { email: this.guestEmail })
        this.showCheckoutAsGuestModal = false
        this.guestEmailRegistered = false
        this.gotoBilling()
      } catch (e) {
        this.guestEmailRegistered = true
      } finally {
        this.isCheckingGuestEmail = false
      }
    },

    gotoBilling() {
      if (this.billingEnabled) {
        this.setBillingTotal(this.costDetails)
        this.setBillingGuestEmail(this.guestEmail)
        this.setCheckoutState('billing')
      } else {
        this.$once('cart.processing.error', async (e) => {
          await this.$nextTick()
          if (this.validationError === 'Unknown error!') {
            const message = 'Unfortunately, there are issues with this order. Please try one more time later.'
            this.setValidationError(message)
          }
        })
        this.$once('paid', () => {
          this.stopTimer()
          this.clearCartItems()
          this.setCheckoutState('final')
        })
        this.submitCart({})
      }
    },
    gotoLoginPage() {
      const cartPage = 'page-cart'
      this.setPostLoginPage(cartPage)
      this.setPostLoginSection('billing')
      this.gotoLogin()
      // this.showLoginPrompt = false
    },
    gotoSignUpPage() {
      const cartPage = 'page-cart'
      this.setPostLoginPage(cartPage)
      this.setPostLoginSection('billing')
      this.gotoRegistration()
      // this.showLoginPrompt = false
    },
    goBackFromCart() {
      EventBus.$emit('cart-go-back', this)
      window.location.href = '/'
    },
    cleanMyCart() {
      this.showClearCartPrompt = true
    },
    finallyCleanMyCart() {
      EventBus.$emit('cart-cleaned', this)
      this.clearCartItems()
      this.showClearCartPrompt = false
    },
    finallyDontCleanMyCart() {
      this.showClearCartPrompt = false
    },

    async addCoupon() {
      const code = this.coupon.code
      const codeExists = this.isCouponExists(code)

      if (codeExists) {
        this.coupon.error = 'This code is already added.'
        return
      }
      this.resetCouponInput()

      try {
        this.coupon.isAdding = true
        await this.$nextTick()

        const options = {code}
        await axios.post(`${window.addiesaas.url}/api/customer/coupon/check`, options)

        await this.addDiscount({
          id: `coupon_${code}`,
          title: code,
          type: 'coupon',
          payload: {
            type: 'coupon',
            options
          },
        })

        this.coupon.error = null
        await EventBus.$$emitAsync('cart.validate')

        await this.$nextTick()
        const appliedData = this.getCouponData(code)
        const isApplied = appliedData && appliedData.applied
        this.coupon.isAdded = isApplied
        this.coupon.notApplied = !isApplied
        if (!isApplied) {
          const message = this.getCouponError(appliedData, 'Coupon can not be applied.')
          this.coupon.error = message
        } else {
          this.coupon.code = null
        }

      } catch (e) {
        this.coupon.error = getFirstErrorMessage(e)
      } finally {
        await this.$nextTick()
        this.coupon.isAdding = false
      }
    },

    coupons(summary) {
      const discounts = _.get(summary, 'discounts.data', [])
      return discounts.filter(x => x.type === 'coupon')
    },

    couponsTotal(summary) {
      const initial = {
        fee_discount: 0,
        fee_tax_discount: 0,
        price_discount: 0,
        tax_discount: 0,
      }
      const coupons = this.coupons(summary)
      if (coupons.length > 0) {
        return coupons.reduce((a, x) => {
          return {
            fee_discount: a.fee_discount + x.fee_discount,
            fee_tax_discount: a.fee_tax_discount + x.fee_tax_discount,
            price_discount: a.price_discount + x.price_discount,
            tax_discount: a.tax_discount + x.tax_discount,
          }
        }, initial)
      } else {
        return initial
      }
    },

    deleteCoupon(code) {
      const coupon = Object
        .values(this.cartDiscounts)
        .filter(x => x.type === 'coupon' && x.payload.options.code === code)
        .forEach(discount => {
          this.removeCartDiscount({ id: discount.id })
        })
        this.resetCouponInput(true)
        EventBus.$emit('cart.validate')
    },

    async addGiftcard() {
      this.resetGiftcardInput()
      try {
        this.giftcard.isAdding = true

        this.giftcard.options = {
          number: this.giftcard.number,
          cvv: this.giftcard.cvv,
        }

        const { data: { data: giftcard } } = await axios.post(`${window.addiesaas.url}/api/customer/giftcard/check`, this.giftcard.options)

        this.giftcard.options.amount = Number(giftcard.balance)
        this.showGiftcardFullPartialModal = true
      } catch (e) {
        this.giftcard.error = getFirstErrorMessage(e)
      } finally {
        this.giftcard.isAdding = false
      }
    },

    async applyGiftcard(amount) {
      this.showGiftcardFullPartialModal = this.showGiftcardAmountModal = false

      const id = `giftcard_${this.giftcard.number}`

      if (amount !== null) {
        amount = Number(amount)

        if (id in this.cartDiscounts) {
          amount += this.cartDiscounts[id].payload.options.amount
        }

        if (amount > this.giftcard.options.amount) {
          this.giftcard.error = 'The selected amount is not available on your Gift Card.'
          return
        }

        this.giftcard.options.amount = amount
      }

      this.resetGiftcardInput()

      this.giftcard.isAdding = true

      this.addDiscount({
        id,
        title: this.giftcard.number,
        type: 'giftcard',
        payload: {
          type: 'giftcard',
          options: this.giftcard.options
        },
      })

      this.$set(this.giftcard, 'number', null)
      this.$set(this.giftcard, 'cvv', null)

      try {
        this.giftcard.error = null
        await EventBus.$$emitAsync('cart.validate')

        await this.$nextTick()
        const appliedData = this.getGiftcardData(id)
        const isApplied = _.get(appliedData, 'discount.applied')

        this.giftcard.isAdded = isApplied
        this.giftcard.notApplied = !isApplied

        if (isApplied) {
          this.giftcard.number = null
          this.giftcard.cvv = null
          this.giftcard.amount = null
        } else {
          this.giftcard.itemId = id
          const message = this.getGiftcardError(appliedData, 'Gift card is not applied.')
          this.giftcard.error = message
        }
      } catch (e) {
        this.giftcard.error = getFirstErrorMessage(e)
      } finally {
        await this.$nextTick()
        this.giftcard.isAdding = false
      }
    },

    giftcards(summary) {
      return Object
        .values(this.cartDiscounts)
        .filter(x => x.type === 'giftcard')
        .map(x => {
          const discount = summary ?
            summary.discounts.data.find(y => y.type === 'giftcard' && y.options.number === x.payload.options.number) : {}
          return Object.assign({}, x, { discount })
        })
    },

    giftcardsDiscount(summary) {
      if (summary) {
        return summary.discounts.data
          .filter(x => x.type === 'giftcard')
          .map(x => -(x.price_discount + x.tax_discount))
          .reduce((total, x) => total + x, 0)
      }
    },

    deleteGiftcard(id) {
      this.removeCartDiscount({ id })
      this.resetGiftcardInput(true)
      EventBus.$emit('cart.validate')
    },

    switchRedemptionPanel(type) {
      this.selectedRedemption = type
      this.resetCouponInput(true)
      this.resetGiftcardInput(true)
    },
    resetGiftcardInput(clean) {
      this.giftcard.isAdded = false
      this.giftcard.error = null
      this.giftcard.notApplied = false
      this.giftcard.itemId = null
      if (clean) {
        this.giftcard.cvv = null
        this.giftcard.number = null
        this.giftcard.amount = null
      }
    },
    resetCouponInput(clean) {
      this.coupon.isAdded = false
      this.coupon.error = null
      this.coupon.notApplied = false
      if (clean) {
        this.coupon.code = null
      }
    },
    getCouponData(code) {
      const discounts = this.coupons(this.costDetails)
      return _.find(discounts, x => x.options.code === code)
    },
    isCouponExists(code) {
      return !!this.getCouponData(code)
    },
    getGiftcardData(id) {
      const discounts = this.giftcards(this.costDetails)
      return _.find(discounts, x => x.id === id && x.discount)
    },
    getCouponError(coupon, defaultMessage = 'Not applied') {
      return _.get(coupon, 'messages.errors.0') || defaultMessage
    },
    getGiftcardError(giftcard, defaultMessage = 'Not applied') {
      return _.get(giftcard, 'discount.messages.errors.0') || defaultMessage
    }
  }
}
